"use client";

/** Sends a page crash to the app (Cloudflare log + Admin → Processing log). Best effort, once per error. */
const sent = new WeakSet<object>();

export function reportCrash(error: Error & { digest?: string }, component?: string): void {
  try {
    if (sent.has(error)) return;
    sent.add(error);
    const body = JSON.stringify({
      page: window.location.pathname,
      message: String(error?.message ?? error),
      digest: error?.digest,
      stack: error?.stack,
      component,
    });
    if (navigator.sendBeacon) navigator.sendBeacon("/api/client-errors", new Blob([body], { type: "application/json" }));
    else void fetch("/api/client-errors", { method: "POST", body, keepalive: true, headers: { "content-type": "application/json" } });
  } catch {
    // never let reporting cause another problem
  }
}

const migrationsSent = new Set<string>();

/** Best-effort staging evidence for the temporary editor migration. Sends no draft or creator content. */
export function reportEditorMigration(status: "parity_ok" | "parity_mismatch" | "invalid_unified", draftKey: string): void {
  try {
    const once = `${status}:${draftKey}`;
    if (migrationsSent.has(once)) return;
    migrationsSent.add(once);
    const body = JSON.stringify({ kind: "editor_migration", status, page: window.location.pathname });
    if (navigator.sendBeacon) navigator.sendBeacon("/api/client-errors", new Blob([body], { type: "application/json" }));
    else void fetch("/api/client-errors", { method: "POST", body, keepalive: true, headers: { "content-type": "application/json" } });
  } catch {
    // Migration diagnostics must never affect editing.
  }
}
